module.exports = __webpack_public_path__ + "static/media/phone-black.fc8ae874.svg";